import { ComponentProps, ReactNode } from 'react';

type InputWrapped = {
  label?: ReactNode | string;
  name: string;
  description?: string;
  defaultValue?: string;
  register?: any;
} & Partial<ComponentProps<'textarea'>>;

export const TextareaWrapped = ({ name, description, label, defaultValue, register, ...props }: InputWrapped) => {
  return (
    <div className="layout-column layout-align-start-start">
      {label && <div className="mb-2 layout-row layout-align-start-center">{label}</div>}
      {description && <p className="mb-4">{description}</p>}

      <textarea
        rows={5}
        defaultValue={defaultValue}
        className="width-100"
        {...(register && register(name))}
        name={name}
        {...props}></textarea>
    </div>
  );
};
